import { Dispatch } from "redux";

import {
  ERPSeedless,
  ERPRJL,
  ERPUnity,
  ERPOdoo,
  ERPZertus
} from "src/utils/constants";
import { toggleNotifications } from "src/core/notifications/store/notifications.actions";
import { IRoute } from "src/pages/Router/routes";
import { Icons } from "src/library/components/Icon/types";

export const footerItems = (dispatch: Dispatch): IRoute[] => [
  {
    title: "Smart Settings",
    roles: [ "customer" ],
    icon: Icons.BOLT,
    path: "/smart-settings/user",
    privateRoute: true,
    menuType: "MAIN",
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo,
      ERPZertus
    ]
  },
  {
    title: "Notifications",
    roles: [ "customer", "admin" ],
    icon: Icons.BELL,
    path: "/notifications",
    privateRoute: true,
    menuType: "NONE",
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo,
      ERPZertus
    ],
    onClick: () => dispatch(toggleNotifications(true, null))
  },
  {
    title: "Jobs Queue",
    roles: [ "admin" ],
    icon: Icons.QUEUE,
    path: "/platform/process-job-queue",
    privateRoute: true,
    menuType: "NONE"
  },
  {
    path: "/support",
    title: "Help",
    roles: [ "customer" ],
    icon: Icons.HELP,
    menuType: "MAIN",
    privateRoute: true
  },
  {
    title: "Settings",
    path: "/settings/user",
    roles: [ "customer" ],
    privateRoute: true,
    icon: Icons.PERSON,
    menuType: "MAIN",
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo,
      ERPZertus
    ]
  },
  {
    path: "/support",
    title: "Help",
    roles: [ "admin" ],
    menuType: "ADMIN_MAIN",
    privateRoute: true,
    icon: Icons.HELP
  },
  {
    path: "/logout",
    menuType: "NONE",
    icon: Icons.LOGOUT,
    title: "Logout"
  }
];
